import {ExtendedDataProvider, GeneralFilterProps, SelectItem} from "../../types";
import { useDataProvider } from "react-admin";
import React, {useEffect, useState} from "react";
import DebounceSelect from "../Common/DebounceSelect";

const ServiceTagFilter =  ({ filterValues , setFilterValues }: GeneralFilterProps) => {
    const [selectedTags, setSelectedTags] = useState<any>([]);

    const dataProvider: ExtendedDataProvider = useDataProvider();

    const fetchTagList = async (values: string): Promise<any> => {
        return dataProvider.getAction("browse_services", {
            verb: 'tags',
            filter: {
                'name': values
            }
        })
            .then((data: any) => {
                return data.data.results.map((result: any) => ({
                    label: result.name,
                    value: result.name
                }))
            })
            .catch((error: any) => console.log(error))
    }
    useEffect(() => {
        setFilterValues({ ...filterValues, 'tags': selectedTags.join() })
    }, [selectedTags])


    return (
        <DebounceSelect
            createable={false}
            mode="multiple"
            showSearch
            maxTagCount="responsive"
            placeholder="Select Tags"
            fetchOptions={fetchTagList}
            value={selectedTags}
            onChangeSelect={newValue => {
                // @ts-ignore
                setSelectedTags(newValue.map((tag: any) => tag.value));
            }}
            style={{ width: '100%' }}
            className="filter-select"
        />
    )

}



export default ServiceTagFilter;

